import React from 'react';
import './index.scss';
import Rotate from 'common/components/rotate';
import RecommendProduct from 'common/components/recommend';
import HotProduct from '../HotProduct';
import CarInsure from '../CarInsure';
import Consult from '../Consult';
import JdInsure from '../JdInsure';
import { IFloor } from 'lib/types';
interface IProps {
  floorsList: IFloor[];
}
const Floors = (props: IProps) => {
  const { floorsList } = props;
  return (
    <div className='floor_wrap'>
      {floorsList.map((floor, index) => {
        return (
          <section key={index}>
            {floor.type === 'combAdTurn3' && (
              <Rotate data={floor.combAdTurn3.data} />
            )}

            {floor.type === 'jingxuan' && (
              <RecommendProduct jingxuan={floor.jingxuan} />
            )}

            {floor.type === 'jingxuan_hot' && (
              <HotProduct productList={floor.jingxuan_hot} />
            )}

            {floor.type === 'combRecommendMove1' && (
              <CarInsure dataInfo={floor.combRecommendMove1} />
            )}

            {floor.type === 'combRecommend2' && (
              <Consult dataInfo={floor.combRecommend2} />
            )}

            {floor.type === 'img' && <JdInsure dataInfo={floor.img} />}
          </section>
        );
      })}
    </div>
  );
};

export default Floors;
